// Implements: F-SHR-006
/**
 * Mockup v3 P8: the expiry a person picks from a select ("7 días", "30 días", "90 días", "Sin
 * caducidad"), where the free number of days used to be typed.
 *
 * The client refuses nothing: the server still judges the days against `SHARE_LINK_MAX_EXPIRY_DAYS`
 * and whether the one-year "1 año" is offered (`SHARE_LINK_ALLOW_NO_EXPIRY`), and its `422`
 * sentence is shown as it comes. A new link starts on 30 days (`DEFAULT_EXPIRY`); an edit offers
 * "leave it as it is" first. "1 año" lasts one year (owner decision 2026-10-19).
 */
export type ExpiryChoice = 7 | 30 | 90 | "never";

export const EXPIRY_CHOICES: readonly ExpiryChoice[] = [7, 30, 90, "never"];

/** What a new link starts on: "30 días" (owner decision 2026-10-19, as in v3). */
export const DEFAULT_EXPIRY: ExpiryChoice = 30;

/** The body fields of one choice: never both a number of days and the no-expiry flag (C3/C4). */
export function expiryInput(choice: ExpiryChoice): { readonly expires_in_days: number } | { readonly never_expires: true } {
  return choice === "never" ? { never_expires: true } : { expires_in_days: choice };
}

/** A select's value read back as a choice; anything else is `null`. */
export function expiryChoiceOf(value: string): ExpiryChoice | null {
  return EXPIRY_CHOICES.find((choice) => String(choice) === value) ?? null;
}
